'use client'
import { create } from 'zustand'

export type ServiceStatus = 'online' | 'busy' | 'offline'

export interface ServicePresence {
  id:      string
  label:   string
  status:  ServiceStatus
  detail?: string
}

const INITIAL_SERVICES: ServicePresence[] = [
  { id: 'ticoune', label: 'Ti-Coune AI',     status: 'online', detail: 'Orchestrator actif'     },
  { id: 'legal',   label: 'Legal Extractor', status: 'busy',   detail: 'Extraction en cours'    },
  { id: 'vector',  label: 'Vector Pipeline', status: 'online', detail: 'Qdrant 192.168.1.97'     },
  { id: 'ollama',  label: 'Ollama',          status: 'online', detail: '192.168.1.96:11434'      },
  { id: 'qdrant',  label: 'Qdrant',          status: 'online', detail: '192.168.1.97:6333'       },
]

interface PresenceState {
  services: ServicePresence[]
  setServiceStatus: (id: string, status: ServiceStatus, detail?: string) => void
}

export const usePresenceStore = create<PresenceState>((set) => ({
  services: INITIAL_SERVICES,
  setServiceStatus: (id, status, detail) =>
    set((s) => ({
      services: s.services.map((svc) =>
        svc.id === id ? { ...svc, status, ...(detail ? { detail } : {}) } : svc,
      ),
    })),
}))
